import React, { useMemo } from 'react';
import Link from '@atlaskit/link';
import { LinkProps, useLocation } from 'react-router-dom';
import { useRegisterComponent } from '../../orchestrator';

export const ResetPasswordLink = ({ children }: { children: React.ReactNode }) => {
  useRegisterComponent(ResetPasswordLink.name);

  const location = useLocation();

  const resetPasswordLink = useMemo(
    () => '/login/resetpassword' + location.search,
    [location.search]
  );

  return (
    <Link<LinkProps> href={resetPasswordLink} id="resetPassword">
      {children}
    </Link>
  );
};
